import React from 'react';
import App from '../App';

export function Enrollments() {
  return <App />;
}